/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {SELECTOR_USER} from '../../redux/selectors/auth';
import {SELECTOR_ADDRESSES} from '../../redux/selectors/addresses';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import {Link, useRouteMatch} from 'react-router-dom';
import {SELECTOR_FULFILLMENT_CURRENT} from '../../redux/selectors/fulfillments';
import CurrencyFormat from 'react-currency-format';
import Typography from '@material-ui/core/Typography';
import {useDispatch} from 'react-redux';
import {getAddresses} from '../../redux/actions';

const Title = ({children}) => {
  return <span style={{display: 'inline-block', width: 100, fontWeight: 700}}>{children}</span>;
};

const useStyles = makeStyles((theme) => ({
  card: {
    border: '1px solid rgba(122,122,122,0.6)',
    borderRadius: 10,
    padding: '15px 20px',
  },
  textNormal: {
    fontWeight: 400,
  },
}));

Resume.propTypes = {
  //
};

function Resume(props) {
  const user = useSelector(SELECTOR_USER);
  const address = useSelector((state) => SELECTOR_ADDRESSES(state).find((it) => it.main === 'true'));
  const delivery = useSelector(SELECTOR_FULFILLMENT_CURRENT);

  const dispatch = useDispatch();

  const match = useRouteMatch('/checkout/:section');
  const classes = useStyles();

  function _fetch() {
    dispatch(getAddresses());
  }

  useEffect(() => {
   _fetch();
  }, [])

  return (
    <>
      {/* <Box display="flex" justifyContent="center">
        <div style={{width: "100%"}}>
          <div style={{ justifyContent:"center", alignItems:"center", backgroundColor:"#fffeec", padding: 16, marginBottom:10}}>
          <Typography
            color="textPrimary"
            style={{textAlign: "center"}}
            >
              Para compras realizadas en los días 17, 18, 19, 20 y 21 de febrero los despachos de los pedidos se realizarán a partir del 22 de febrero por motivo de Carnaval de Barranquilla en nuestra sede principal ubicada en esta ciudad.
          </Typography>
          </div>
        </div>
      </Box> */}
      <div className={classes.card}>
        <Box py={1} className={classes.textNormal}>
          <Title>Contacto:&nbsp;</Title>
          {user.first_name} {user.last_name}.
        </Box>
        {['delivery', 'pay'].includes(match.params.section) && (
          <React.Fragment>
            <Divider />
            <Box display={'flex'} justifyContent={'space-between'} py={1}>
              <div className={classes.textNormal}>
                <Title>Enviar a:&nbsp;</Title>
                <div style={{}}>
                  {address?.address} - {address?.city.name}, {address?.state.name}.
                </div>
              </div>
              <Link to={'/checkout/info'}>cambiar</Link>
            </Box>
          </React.Fragment>
        )}
        {['pay'].includes(match.params.section) && delivery && (
          <React.Fragment>
            <Divider />
            <Box display={'flex'} justifyContent={'space-between'} py={1}>
              <CurrencyFormat
                value={delivery?.price}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
                renderText={(value) => (
                  <Typography variant="inherit" className={classes.textNormal}>
                    <Title>Método:&nbsp;</Title>
                    {delivery?.fulfillmentCompany?.name} {value === '$0' ? '$0 - Envio Gratis' : value}
                  </Typography>
                )}
              />
              <Link to={'/checkout/delivery'}>cambiar</Link>
            </Box>
          </React.Fragment>
        )}
      </div>
    </>
  );
}

export default Resume;
